(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["finance-options"]) return;
  try {
    
(function () {
    var data = JSON.parse(document.getElementById('finance-options-data').innerText);
    if (!data.blocks.length) return;

    var optionsHtml = document.getElementById('finance-options').innerHTML;

    document.querySelectorAll('[data-role="finance-options"]').forEach(function (element) {
        element.innerHTML = optionsHtml;
    });

    var popup = document.getElementById('finance-options-popup-wrapper');
    var bodyOverflow = document.body.style.overflow;
    popup.open = function () {
        this.style.display = 'block';
        document.body.style.overflow = 'hidden';
    }.bind(popup);
    popup.close = function () {
        this.style.display = 'none';
        document.body.style.overflow = bodyOverflow;
    }.bind(popup);

    document.addEventListener('click', function (event) {
        if (['finance-options-popup-wrapper', 'finance-options-popup-close'].indexOf(event.target.id) !== -1) popup.close();
        if (!event.target.classList.contains('finance-options-popup-open')) return;
        event.preventDefault();
        popup.open();
    });

    document.addEventListener('change', function (event) {
        if (!event.target.hasAttribute('data-product-price')) return;
        var price = parseInt(event.target.getAttribute('data-product-price'));
        var paymentPeriod = '';
        if (price > data.settings.weekly_threshold * 100) paymentPeriod = 'weekly';
        if (price > data.settings.fortnightly_threshold * 100) paymentPeriod = 'fortnightly';
        if (price > data.settings.monthly_threshold * 100) paymentPeriod = 'monthly';

        var applicableOptions = data.blocks.filter(function (block) {
            var enabled = block.settings.enabled,
                // applies = block.settings.applies,
                // min = block.settings.min * 100,
                // max = block.settings.max * 100 || Infinity,
                visible = block.settings.show_in_form,
                from = block.settings.show_in_form_from * 100,
                to = block.settings.show_in_form_to * 100 || Infinity;
            // return enabled && visible && applies === paymentPeriod && min <= price && max > price;
            return enabled && visible && from <= price && to > price;
        });

        document.querySelectorAll('[data-role="finance-option-offer"]').forEach(function (element) {
            var html = '';

            var formatPrice = function (cents) {
                return '$' + (cents / 100).toFixed(2);
            };

            if (paymentPeriod === 'weekly') {
                html = data.strings.label_weekly.replace(/{{amount}}/g, formatPrice(price / 52));
            } else if (paymentPeriod === 'fortnightly') {
                html = data.strings.label_fortnightly.replace(/{{amount}}/g, formatPrice(price / 4));
            } else if (paymentPeriod === 'monthly') {
                html = data.strings.label_monthly.replace(/{{amount}}/g, formatPrice(price / 3));
            }

            element.innerHTML = html;
        });

        document.querySelectorAll('[data-role="finance-option-logos"]').forEach(function (element) {
            var html = applicableOptions.map(function (option) {
                return option.settings.logo_svg;
            }).join('\n');
            element.innerHTML = html;
        });
    });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-badges"]) return;
  try {
    
(function () {
    var productBadges = document.getElementById('product-badges');  
    document.querySelectorAll('[data-role="product-badges"]').forEach(function (e) {
        productTags = e.dataset.tags.split(",");
        document.querySelectorAll('#product-badges [data-role="product-badge"]').forEach(function(badge){
          if(productTags.includes(badge.dataset.tag)){
            e.innerHTML += badge.outerHTML;
          }
        });        
    });  
})();

  } catch(e) { console.error(e); }
})();
})();
